import { CustomAction } from "..";
import { AUTH_ACTION_TYPES } from "../actions-types";
import { AuthState } from "../../types/auth";

export const defaultState: AuthState = {
  type: null,
  status: "unknown",
  isLoggedIn: false,
  emailBanDuration: "",
};

export const authReducer = (
  state = defaultState,
  action: CustomAction
): AuthState => {
  switch (action.type) {
    case AUTH_ACTION_TYPES.SET_AUTH_TYPE:
      return {
        ...state,
        type: action.data,
      };
    // status and isLoggedIn are always written together so they cannot diverge
    case AUTH_ACTION_TYPES.SET_AUTH_STATUS:
      return {
        ...state,
        status: action.data,
        isLoggedIn: action.data === "authenticated",
      };
    case AUTH_ACTION_TYPES.SET_AUTH_LOGGED_IN:
      return {
        ...state,
        isLoggedIn: action.data,
        status: action.data ? "authenticated" : "anonymous",
      };
    case AUTH_ACTION_TYPES.SET_AUTH_EMAIL_BAN_DURATION:
      return {
        ...state,
        emailBanDuration: action.data,
      };
    // A reset is a positive statement that there is no session, so it resolves
    // to "anonymous" rather than back to the unresolved "unknown".
    case AUTH_ACTION_TYPES.RESET_AUTH:
      return { ...defaultState, status: "anonymous" };
    default:
      return state;
  }
};
